import React, { FunctionComponent } from 'react';
import { NewIconStyles } from './NewIcon.styles';

export type NewIconTheme = 'whiteOnRed' | 'redOnWhite';
const { Wrapper } = NewIconStyles;

export interface NewIconProps {
  text?: string;
  theme?: NewIconTheme;
}

const NewIcon: FunctionComponent<NewIconProps> = ({ text, theme = 'redOnWhite' }) =>
  text ? <Wrapper theme={theme}>{text}</Wrapper> : null;

export default NewIcon;
